import ISvgProps from '../../../SvgLoader/ISvgProps';

function SvgCalendarLarge(props: ISvgProps) {
	return (
		<svg width={61} height={60} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<g clipPath="url(#CalendarLarge_svg__a)">
				<g clipPath="url(#CalendarLarge_svg__b)">
					<path
						d="M8.067 59.687h44.174c3.495 0 6.395-2.864 6.395-6.38V11.224c0-3.516-2.9-6.354-6.395-6.354h-6.292V1.484c0-.65-.518-1.172-1.165-1.172-.648 0-1.166.521-1.166 1.172V4.87H16.69V1.484c0-.65-.518-1.172-1.165-1.172-.648 0-1.165.521-1.165 1.172V4.87H8.068c-3.496 0-6.396 2.838-6.396 6.354v42.083c0 3.516 2.9 6.38 6.396 6.38Zm44.174-2.343H8.067c-2.213 0-4.065-1.81-4.065-4.037V20.755h52.304v32.552c0 2.227-1.852 4.037-4.066 4.037ZM8.067 7.214h6.292v3.333c0 .651.518 1.172 1.165 1.172.648 0 1.166-.521 1.166-1.172V7.214h26.928v3.333c0 .651.518 1.172 1.165 1.172.648 0 1.166-.521 1.166-1.172V7.214h6.292c2.213 0 4.065 1.783 4.065 4.01v7.187H4.002v-7.187c0-2.227 1.852-4.01 4.066-4.01Z"
						fill={props.primaryColor}
					/>
					<rect x={8.28} y={24.667} width={43.749} height={6} rx={3} fill={props.secondaryColor} />
					<rect x={8.28} y={34} width={36.457} height={6} rx={3} fill={props.secondaryColor} />
				</g>
			</g>
			<defs>
				<clipPath id="CalendarLarge_svg__a">
					<path fill="#fff" transform="translate(.154)" d="M0 0h60v60H0z" />
				</clipPath>
				<clipPath id="CalendarLarge_svg__b">
					<path fill="#fff" transform="translate(1.154)" d="M0 0h58v60H0z" />
				</clipPath>
			</defs>
		</svg>
	);
}

export default SvgCalendarLarge;
